import React from "react";

function SvgWechatFilled(props) {
  return (
    <svg
      width="48px"
      height="48px"
      viewBox="0 0 48 48"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id="WECHATFilled_svg__a"
          d="M42.397 42.396c-2.314 2.432-5.407 3.912-9.279 4.44-2.717.556-5.831.788-9.343.694-3.512.094-6.626-.138-9.343-.695-3.872-.527-6.965-2.007-9.278-4.439-2.432-2.314-3.911-5.406-4.44-9.278-.556-2.717-.787-5.831-.694-9.343-.093-3.512.138-6.626.695-9.343.528-3.872 2.007-6.965 4.439-9.278 2.313-2.432 5.406-3.912 9.278-4.44 2.717-.556 5.831-.787 9.343-.694 3.512-.093 6.626.138 9.343.695 3.872.527 6.965 2.007 9.279 4.439 2.43 2.313 3.91 5.406 4.438 9.278.557 2.717.789 5.831.695 9.343.094 3.512-.138 6.626-.695 9.343-.527 3.872-2.007 6.964-4.438 9.278z"
        />
        <path
          id="WECHATFilled_svg__c"
          d="M7.43 6.103a1.286 1.286 0 110 2.573 1.286 1.286 0 010-2.573zm5.88 0a1.286 1.286 0 11-.001 2.573 1.286 1.286 0 010-2.573zm7.282 11.427c.27-.542.409-1.11.409-1.69 0-1.372-.755-2.58-1.902-3.337a4.87 4.87 0 00-1.857-.738 5.174 5.174 0 00-.878-.08c-2.36 0-4.292 1.594-4.58 3.64-.023.17-.057.338-.057.515 0 .517.119 1.006.312 1.463.663 1.568 2.345 2.691 4.325 2.691a5.01 5.01 0 002.048-.435l.767-.34.78.31.588.231-.148-1.059-.085-.615.278-.556zM9.75 15.403c.242-3.194 3.106-5.718 6.613-5.718.469 0 .927.047 1.369.133 0-.034.007-.068.007-.102C17.74 6.564 14.434 4 10.37 4S3 6.564 3 9.716c0 .973.328 1.938.949 2.788l.436.598-.06.738-.136 1.741.83-.592.902-.642 1.023.422a8.804 8.804 0 002.807.634zM23 15.84c0 .925-.227 1.798-.621 2.586l.62 4.457-3.776-1.496a7.034 7.034 0 01-2.86.607c-3.08 0-5.66-1.946-6.41-4.582a10.952 10.952 0 01-3.773-.794l-4.323 3.08.475-6.016C1.488 12.523 1 11.167 1 9.716 1 5.454 5.196 2 10.37 2c5.175 0 9.37 3.454 9.37 7.716 0 .271-.018.54-.051.803C21.667 11.585 23 13.566 23 15.84zm-4.36-1.644a1.099 1.099 0 110 2.197 1.099 1.099 0 010-2.197zm-4.409 0a1.099 1.099 0 110 2.197 1.099 1.099 0 010-2.197z"
        />
      </defs>
      <g fill="none" fillRule="evenodd">
        <mask id="WECHATFilled_svg__b" fill="#fff">
          <use xlinkHref="#WECHATFilled_svg__a" />
        </mask>
        <use fill="#BABABA" xlinkHref="#WECHATFilled_svg__a" />
        <g fill="#EBECF0" mask="url(#WECHATFilled_svg__b)">
          <path d="M0 0h48v48H0z" />
        </g>
        <g transform="translate(12 12)">
          <mask id="WECHATFilled_svg__d" fill="#fff">
            <use xlinkHref="#WECHATFilled_svg__c" />
          </mask>
          <use fill="#000" xlinkHref="#WECHATFilled_svg__c" />
          <g fill="#091E42" mask="url(#WECHATFilled_svg__d)">
            <path d="M0 0h24v24H0z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgWechatFilled;
